import { Theme } from '@mui/material/styles';

type TypographyOptions = Theme['typography'];

const bodyFont = "'Inter', sans-serif";
const displayFont = "'Clash Display', 'Inter', sans-serif";
const monoFont = "'Fira Code', monospace";

export const typography: TypographyOptions = {
    fontFamily: bodyFont,
    fontSize: 14,
    htmlFontSize: 16,
    pxToRem: (size: number) => `${size / 16}rem`,
    fontWeightLight: 400,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 600,
    display1: {
        fontFamily: displayFont,
        fontSize: "clamp(3.2rem, 7vw, 7.2rem)",
        fontWeight: 500,
        lineHeight: 0.98,
        letterSpacing: "-0.02em",
    },
    display2: {
        fontFamily: displayFont,
        fontSize: "clamp(2.4rem, 5vw, 4.6rem)",
        fontWeight: 500,
        lineHeight: 1.02,
        letterSpacing: "-0.01em",
    },
    h1: {
        fontFamily: displayFont,
        fontSize: "clamp(2rem, 4vw, 2.8rem)",
        fontWeight: 500,
        lineHeight: 1.1,
        letterSpacing: "-0.01em",
    },
    h2: {
        fontFamily: displayFont,
        fontSize: "clamp(1.6rem, 3vw, 2.1rem)",
        fontWeight: 500,
        lineHeight: 1.15,
    },
    h3: {
        fontFamily: displayFont,
        fontSize: "clamp(1.35rem, 2.4vw, 1.7rem)",
        fontWeight: 500,
        lineHeight: 1.2,
    },
    h4: {
        fontFamily: displayFont,
        fontSize: "1.25rem",
        fontWeight: 500,
        lineHeight: 1.3,
    },
    h5: {
        fontFamily: displayFont,
        fontSize: "1.1rem",
        fontWeight: 500,
        lineHeight: 1.4,
    },
    h6: {
        fontFamily: displayFont,
        fontSize: "1rem",
        fontWeight: 500,
        lineHeight: 1.4,
    },
    subtitle1: {
        fontSize: "1.05rem",
        fontWeight: 400,
        lineHeight: 1.5,
        color: 'rgba(17, 17, 17, 0.62)',
    },
    subtitle2: {
        fontFamily: monoFont,
        fontSize: "0.78rem",
        fontWeight: 500,
        letterSpacing: "0.08em",
        textTransform: "uppercase" as const,
        lineHeight: 1.4,
    },
    body1: {
        fontSize: "1rem",
        fontWeight: 400,
        lineHeight: 1.65,
    },
    body2: {
        fontSize: "0.9rem",
        fontWeight: 400,
        lineHeight: 1.6,
    },
    button: {
        fontSize: "0.9rem",
        fontWeight: 500,
        lineHeight: 1.2,
        letterSpacing: "0.02em",
        textTransform: "none" as const,
    },
    caption: {
        fontSize: "0.8rem",
        lineHeight: 1.5,
        color: 'rgba(17, 17, 17, 0.62)',
    },
    overline: {
        fontFamily: monoFont,
        fontSize: "0.72rem",
        fontWeight: 500,
        letterSpacing: "0.08em",
        lineHeight: 1.4,
        textTransform: "uppercase" as const,
    },
};
